export var CONTEXT_ID = 'contextId';
export var JS_ERROR_CODE = 600;
export var DISABLE_TRACKING = 'mt-ui-core/DISABLE_TRACKING';
export var EMPTY_OBJECT_READONLY = Object.freeze({});
//# sourceMappingURL=constants.js.map